export default class SaveDesignToProfileToastMessage {
    static getSaveDesignSuccess(localizedInformationOrTranslations) {
        const label = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.saveDesignToProfileSaveDesignSuccess
            : localizedInformationOrTranslations.saveDesignToProfileSaveDesignSuccess;
        return {
            label
        };
    }
    static getSaveDesignFailure(localizedInformationOrTranslations) {
        const label = 'translations' in localizedInformationOrTranslations
            ? localizedInformationOrTranslations.translations.saveDesignToProfileSaveDesignFailure
            : localizedInformationOrTranslations.saveDesignToProfileSaveDesignFailure;
        return {
            label
        };
    }
}
//# sourceMappingURL=SaveDesignToProfileToastMessage.js.map